module.exports = __webpack_public_path__ + "img/code_2.7ccdfff6.jpg";